/**
 * The seam where a cross-Workspace publication set stops being JSON and starts
 * being an object this bundle is allowed to call `.includes()` on.
 *
 * ONE FUNCTION, SIX SURFACES. Migration 0166 reshaped credential SHARES from
 * `{ allOrgs, orgIds }` to `{ orgIds, viaAllOrgIds }`; migration 0168 (`3e50f6d`,
 * the same day) did exactly the same to PUBLICATIONS on skills, connectors,
 * templates, permissions, roles and approval rules. The number of places this
 * defect can live is therefore not a guess — it is the list of surfaces 0168
 * touched, and this file is applied at every one of their `listAll()` reads.
 *
 * WHAT THE 0166 HALF COST, 2026-08-01 → 2026-08-02 (`ff81bb7`). Every reader
 * treats these as arrays. One absent field threw `TypeError: Cannot read
 * properties of undefined (reading 'includes')` out of credential-detail-v2's
 * Grants tab — which React evaluates while building the element tree no matter
 * which tab is open — and the settings error boundary ate the whole section.
 * Opening ANY credential, on ANY device, read "This section failed to load",
 * for six commits.
 *
 * A GUARD AT THE READ SITE DOES NOT WORK, AND CANNOT. `?? { orgIds: [],
 * viaAllOrgIds: [] }` defends against an ABSENT container; what arrives from a
 * gateway of a different vintage is a PRESENT container with a missing field.
 * That distinction is the whole defect, and it is why this is done once, here,
 * rather than at the twenty-odd call sites across five matrix components —
 * twenty guards is twenty places for the twenty-first to be forgotten.
 *
 * THE TYPE IS NOT THE WIRE. `SkillPublications`, `ConnectorPublications`,
 * `TemplatePublications`, `PermissionPublications`, `RolePublications` and
 * `CredentialShares` are TypeScript interfaces, and TypeScript is not on the
 * wire. This JSON comes from a gateway that is built, baked and restarted
 * SEPARATELY from this bundle — /srv/chaos/deploy-log.jsonl routinely shows the
 * two bakes landing tens of minutes apart — so for the length of every deploy
 * the two disagree by a release. A pre-0168 gateway answers
 * `{ allOrgs, orgIds }`, with no `viaAllOrgIds` at all. Whoever reads the
 * interface next will conclude the field is guaranteed. It is not; this file is
 * the only reason it behaves as though it were.
 *
 * `Array.isArray` AND NOT `??`, deliberately: `null`, a string and an object all
 * have to land on `[]` too, and a nullish coalesce catches exactly one of those
 * three. A string is the nastiest — `new Set('abc')` is three entries, not a
 * throw, so the wrong shape would render as data rather than as an error.
 */

/**
 * WHERE an item is published, and which of those marks the "All Workspaces"
 * select-all button placed. Structurally identical to the six per-catalog
 * interfaces, so the normalised value is assignable to each of them.
 */
export interface OrgPublicationSet {
  orgIds: string[];
  viaAllOrgIds: string[];
}

/** Make both lists REAL, whatever the gateway actually put on the wire. */
export function normalizeOrgPublications(
  pub: Partial<OrgPublicationSet> | null | undefined,
): OrgPublicationSet {
  return {
    orgIds: Array.isArray(pub?.orgIds) ? pub.orgIds : [],
    viaAllOrgIds: Array.isArray(pub?.viaAllOrgIds) ? pub.viaAllOrgIds : [],
  };
}

/**
 * The same guarantee for a bare list field, for the places a row carries one
 * directly rather than inside a publication container (`ApprovalRuleRow.modes`
 * is read as `row.modes.includes(m)` and `row.modes.length` during render, so
 * an absent one takes the Automation-rules section down the same way).
 *
 * `fallback` is the value used when the wire carries anything that is not an
 * array — pass the list the row would have meant, not always `[]`.
 */
export function normalizeList<T>(value: unknown, fallback: T[]): T[] {
  return Array.isArray(value) ? (value as T[]) : fallback;
}
